import React from 'react'

const Algo = () => {
    return (
        <div className='container'>
            <h1>Algorithm in C Language</h1>
           
          <p>  Algorithm is a step-by-step procedure, which defines a set of instructions to be executed in a certain order to get the desired output. Algorithms are generally created independent of underlying languages, i.e. an algorithm can be implemented in more than one programming language. <br /> <br />
            From the data structure point of view, following are some important categories of algorithms −
 <br /> <br />
Search − Algorithm to search an item in a data structure. <br />
Sort − Algorithm to sort items in a certain order. <br />
Insert − Algorithm to insert item in a data structure. <br />
Update − Algorithm to update an existing item in a data structure. <br />
Delete − Algorithm to delete an existing item from a data structure.</p>
            
            <h3>Characteristics of an Algorithm</h3>
           
         <p>Not all procedures can be called an algorithm. An algorithm <br />
             should have the following characteristics − <br /> <br />

Unambiguous − Algorithm should be clear and unambiguous. Each of its steps <br />
 (or phases), and their inputs/outputs should be clear and must lead to only one meaning. <br />
Input − An algorithm should have 0 or more well-defined inputs. <br />
Output − An algorithm should have 1 or more well-defined outputs, and should  <br />
match the desired output. <br />
Finiteness − Algorithms must terminate after a finite number of steps. <br />
Feasibility − Should be feasible with the available resources. <br />
Independent − An algorithm should have step-by-step directions, which should   <br />
be independent of any programming code. <br />
</p>   
<h3>How to write an Algorithm?</h3>

  <p>  here are no well-defined standards for writing algorithms. Rather,  <br />
    it is problem and resource dependent. Algorithms are never written to support 
    a particular programming code. <br /> <br />

As we know that all programming languages share basic code constructs like loops <br />
 (do, for, while), flow-control (if-else), etc. These common constructs can be used <br />
  to write an algorithm. <br />
 <br />
We write algorithms in a step-by-step manner, but it is not always the case. Algorithm <br />
 writing is a process and is executed after the problem domain is well-defined. That  <br />
 is, we should know the problem domain, for which we are designing a solution. <br />
</p>
<h3>Example</h3>

<p>
Let’s try to learn algorithm-writing by using an example.<br />

Problem − Design an algorithm to add two numbers and display the result.<br />

Step 1 − START<br />

Step 2 − declare three integers a, b & c<br />

Step 3 − define values of a & b<br />

Step 4 − add values of a & b<br />

Step 5 − store output of step 4 to c<br />

Step 6 − print c<br />

Step 7 − STOP<br />

Algorithms tell the programmers how to code the program. Alternatively, 
the algorithm can be written as −<br />

Step 1 − START ADD<br />

Step 2 − get values of a & b<br />

Step 3 − c ← a + b<br />

Step 4 − display c <br />

Step 5 − STOP <br /></p>
<h3>Algorithm Analysis</h3>
<div className='containers'>
    Efficiency of an algorithm can be analyzed at two different stages,<br/>
     before implementation and after implementation. They are the following −<br/>
     <br/>
A Priori Analysis − This is a theoretical analysis of an algorithm. Efficiency<br/>
 of an algorithm is measured by assuming that all other factors, for example, <br/>
 processor speed, are constant and have no effect on the implementation.<br/>
A Posterior Analysis − This is an empirical analysis of an algorithm. The selected <br/>
<br/>
algorithm is implemented using programming language. This is then executed on target<br/>
 computer machine. In this analysis, actual statistics like running time and space <br/>
 required, are collected.<br/>
We shall learn about a priori algorithm analysis. Algorithm analysis deals with the<br/>
 execution or running time of various operations involved. The running time of an <br/>
 operation can be defined as the number of computer instructions executed per <br/>
 operation.<br/>

</div>
<h3>Algorithm Complexity</h3>
<div className='containers'>
Suppose X is an algorithm and n is the size of input data, the time and <br/>
space used by the algorithm X are the two main factors, which decide the efficiency of X.<br/>
<br/>
Time Factor − Time is measured by counting the number of key operations such as<br/>
 comparisons in the sorting algorithm.<br/>
Space Factor − Space is measured by counting the maximum memory space required <br/>
by the algorithm.<br/>
The complexity of an algorithm f(n) gives the running time and/or the storage<br/> 
space required by the algorithm in terms of n as the size of input data.<br/>
        </div>
        <h3>Space Complexity</h3>
        <div className='containers'>
        
Space complexity of an algorithm represents the amount of memory space <br/>
required by the algorithm in its life cycle. The space required by an algorithm <br/>
is equal to the sum of the following two components −<br/>
<br/>
A fixed part that is a space required to store certain data and variables, <br/>
that are independent of the size of the problem. For example, simple variables<br/>
 and constants used, program size, etc.<br/>
A variable part is a space required by variables, whose size depends on the size<br/>
 of the problem. For example, dynamic memory allocation, recursion stack space, etc.<br/>
Space complexity S(P) of any algorithm P is S(P) = C + SP(I), where C is<br/>
 the fixed part and S(I) is the variable part of the algorithm, which depends on <br/>
 instance characteristic I. Following is a simple example that tries to explain <br/>
 the concept −<br/>
 <br/>
Algorithm: SUM(A, B)<br/>
<br/>
Step 1 – START<br/>
<br/>
Step 2 – C ← A + B + 10<br/>

Step 3 – Stop<br/>
<br/>
Here we have three variables A, B, and C and one constant. Hence S(P)<br/>
 = 1 + 3. Now, space depends on data types of given variables and constant<br/>
  types and it will be multiplied accordingly.
       </div>
       <div className='containers'>
           <h3>Time Complexity</h3>
           Time complexity of an algorithm represents the amount of time<br/>
            required by the algorithm to run to completion. Time requirements can<br/>
             be defined as a numerical function T(n), where T(n) can be measured as<br/>
              the number of steps, provided each step consumes constant time.<br/>
              <br/>
For example, addition of two n-bit integers takes n steps. Consequently, the total <br/>
computational time is T(n) = c ∗ n, where c is the time taken for the addition of<br/>
 two bits. Here, we observe that T(n) grows linearly as the input size increases.<br/>


       </div>
        </div>

        
    )
}

export default Algo
